import angular from 'angular';

import fbOl from '../../components/fb-ol';

import emptyItemFilter from '../../filters/empty-item';

import Issue from '../../models/issue';
import Errors from '../../models/errors';
import IssuesTree from '../../models/trees/issues';

import IssuesModalConf from './issues.config';

export default angular.module('modal.issues', [Issue, Errors,
    IssuesTree,
    emptyItemFilter,
    fbOl
  ])
  .constant('IssuesModalConf', IssuesModalConf)
  .name;



// WEBPACK FOOTER //
// ./project/modals/issues/index.js